import { getValue } from "@/components/molecules/SelectBase";

import { Option } from "../models/MultiAutocomplete.types";

const isInclude = <T extends Option>(items: T[], value: T, dataKey: string = "id"): boolean => {
  return items?.some((item) => getValue(item, dataKey) === getValue(value, dataKey));
};

const removeDuplicates = <T extends Option>(items: T[], dataKey: string = "id"): T[] => {
  const seen = new Set();
  return items.filter((item) => {
    const key = item[dataKey];
    if (seen.has(key)) {
      return false;
    }
    seen.add(key);
    return true;
  });
};

const diff = <T extends Option>(itemsA: T[], itemsB: T[], dataKey: string = "id"): T[] => {
  return itemsA.filter((item) => !isInclude(itemsB, item, dataKey));
};

export default {
  isInclude,
  diff,
  removeDuplicates,
};
